import Vue from "vue";
import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Slider,
  Icon,
  Row,
  Col,
  Upload,
  Progress,
  Spinner,
  Badge,
  Card,
  Rate,
  Scrollbar,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Cascader,
  CascaderPanel,
  ColorPicker,
  // Transfer,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Timeline,
  TimelineItem,
  Link,
  Divider,
  Image,
  // Calendar,
  // Backtop,
  // PageHeader,
  Loading,
  MessageBox,
  Message,
  Notification,
  Drawer,
  InfiniteScroll,
  Avatar,
  Popconfirm,
} from "element-ui";

// 全局配置下默认大小和层级
Vue.prototype.$ELEMENT = { size: "small", zIndex: 3000 };

Vue.use(Pagination)
  .use(Dialog)
  .use(Autocomplete)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Menu)
  .use(Submenu)
  .use(MenuItem)
  .use(MenuItemGroup)
  .use(Input)
  .use(InputNumber)
  .use(Radio)
  .use(RadioGroup)
  .use(RadioButton)
  .use(Checkbox)
  .use(CheckboxButton)
  .use(CheckboxGroup)
  .use(Switch)
  .use(Select)
  .use(Option)
  .use(OptionGroup)
  .use(Button)
  .use(ButtonGroup)
  .use(Table)
  .use(TableColumn)
  .use(DatePicker)
  .use(TimeSelect)
  .use(TimePicker)
  .use(Popover)
  .use(Tooltip)
  .use(Breadcrumb)
  .use(BreadcrumbItem)
  .use(Form)
  .use(FormItem)
  .use(Tabs)
  .use(TabPane)
  .use(Tag)
  .use(Tree)
  .use(Alert)
  .use(Slider)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Upload)
  .use(Progress)
  .use(Spinner)
  .use(Badge)
  .use(Card)
  .use(Rate)
  .use(Scrollbar)
  .use(Steps)
  .use(Step)
  .use(Carousel)
  .use(CarouselItem)
  .use(Collapse)
  .use(CollapseItem)
  .use(Cascader)
  .use(CascaderPanel)
  .use(ColorPicker)
  // .use(Transfer)
  .use(Container)
  .use(Header)
  .use(Aside)
  .use(Main)
  .use(Footer)
  .use(Timeline)
  .use(TimelineItem)
  .use(Link)
  .use(Divider)
  .use(Image)
  // .use(Calendar)
  // .use(Backtop)
  // .use(PageHeader)
  .use(Drawer)
  .use(InfiniteScroll)
  .use(Loading.directive)
  .use(Avatar)
  .use(Popconfirm);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
